export default __webpack_public_path__ + "static/media/urban-money-brand.bab81f13.png";